import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useRouter } from 'next/router';

/**
 * App home page only (/apphome): the city picker leaves the search row and sits
 * above it as a badge, so the search field gets the full width and its placeholder
 * is no longer cut on phones (Doctoreto/Jameda put the city outside the field too).
 * Everywhere else — the website, other app pages, and the open suggestion overlay
 * (PlasmicSearchInput's isFocused variant) — keeps production's single row
 * (product decision 2026-10-01).
 * Only with the new home (`apphome::new-home`); the legacy apphome keeps production's box.
 */
export const SEARCH_APP_LAYOUT_CLASS = 'search-app-layout';

export const useAppSearchLayout = () => {
  const { pathname } = useRouter() ?? {};
  const newHome = useFeatureIsOn('apphome::new-home');
  return newHome && pathname === '/apphome';
};

export default useAppSearchLayout;
